// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import VueMoment from 'vue-moment'
import 'es6-promise/auto'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
Raven
    // .config('https://b7e4174463684a81a1a219616a467c92@sentry.io/1493308')
    .addPlugin(RavenVue, Vue)
    .install()
Vue.prototype.$raven = Raven

import vueSeo from '@deveodk/vue-seo'
Vue.use(vueSeo)

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)

Vue.use(VueAxios, axios)
const API_URL = process.env.API_URL + '/'
axios.defaults.baseURL = API_URL

import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
Vue.use(VueToastr, {
    defaultPosition: 'toast-bottom-right',
    defaultType: 'info',
    defaultTimeout: 5000
})

Vue.filter('formattedNumber', function (value) {
    if (!value) return ''
    // let formattedNumber = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    if (value > 999) {
        return Number(value).toFixed(3)
    } else {
        return Number(value).toFixed(0)
    }
})

Vue.filter('withDecimals', (value) => {
    return Number(value).toFixed(2)
})

Vue.filter('rounded', function (value) {
    if (!value) return ''
    return value.toFixed(0)
})

Vue.filter('currency', (value) => {
    let valueInNumbers = value.toString().replace(/\D/g, '')
    let valueWithCommaDecimals = valueInNumbers.replace('.', ',')
    let formattedNumber = valueWithCommaDecimals.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    return formattedNumber
})

Vue.filter('thousand', (value) => {
    let formattedNumber = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return formattedNumber
})

Vue.component('line-data', require('@/components/elements/line-data'))
Vue.component('data-loader', require('@/components/elements/data-loader'))

import errorTracker from '@deveodk/vue-error-tracker'
Vue.use(errorTracker, {
    HttpDriver: require('@deveodk/vue-error-tracker/drivers/http/axios.js'),
    NotificationDriver: require('@deveodk/vue-error-tracker/drivers/notification/deveoToastr.js'),
    ReportDriver: require('@deveodk/vue-error-tracker/drivers/report/sentry.js'),
    HttpErrorCodes: {
        401: {
            title: 'Ingen adgang',
            message: 'Du har ikke adgang til at se dette',
            type: 'error'
        },
        400: {
            title: 'Ukendt fejl',
            message: 'Noget gik galt',
            type: 'error'
        },

        500: {
            title: 'Server fejl',
            message: 'Åhh nej noget er gået galt',
            type: 'error'
        }
    }
})

Vue.use(VueMoment)
require('moment/locale/da')

Vue.config.productionTip = false

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://b7e4174463684a81a1a219616a467c92@sentry.io/1493308',
        integrations: [new Integrations.Vue({Vue, attachProps: true})]
    })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js